module.exports = __webpack_public_path__ + "static/media/m_eyeshape_hooded_grey.52bf7bb3.png";